import { useEffect, useState } from "react";
import { Company } from "../../types/Company";
import { DeleteCompanyModalProps } from "./DeleteCompanyModal";
import { deleteCompanyAsync, getCompanyByIdAsync } from "../../apiClient";
import { showDangerAlert } from "../../common";

function useDeleteCompanyModal(props: DeleteCompanyModalProps) {
    const [company, setCompany] = useState<Company>();
    const [isLoading, setIsLoading] = useState(true);
    const [deleteInProgress, setDeleteInProgress] = useState(false);

    useEffect(() => {
        async function fetchDataAsync() {
            setIsLoading(true);
            const companyResult = await getCompanyByIdAsync(props.companyId);
            setIsLoading(false);

            if (companyResult.failed) {
                console.error("Failed to fetch company with id", props.companyId, "Error:", companyResult.error);
                showDangerAlert(props.resources.get("FetchCompanyError") ?? "");
                props.onHide();
                return;
            }

            setCompany(companyResult.value);
        }

        if (props.show) {
            fetchDataAsync();
        }
    }, [props.companyId, props.show]);

    async function handleDeleteCompanyAsync() {
        setDeleteInProgress(true);
        const deleteResult = await deleteCompanyAsync(props.companyId);
        setDeleteInProgress(false);
        
        if (deleteResult.failed) {
            console.error("Failed to delete company with id", props.companyId, "Error:", deleteResult.error);
            showDangerAlert(props.resources.get("DeleteCompanyError") ?? "");
            props.onHide();
            return;
        }

        props.onCompanyDeleted();
        props.onHide();
    }

    return {
        company,
        isLoading,
        deleteInProgress,
        handleDeleteCompanyAsync
    };
}

export default useDeleteCompanyModal;
